export enum AccountRole {
  Admin = "Admin",
  UserManager = "UserManager",
  ProjectManager = "ProjectManager",
}

export interface CreateAccount {
  name: string;
  adminEmail: string;
}

export interface AccountStats {
  nProjects: number;
  nAccountUsers: number;
}

export interface AccountUser {
  id: string;
  email: string;
  roles: AccountRole[];
  createdAt: string;
}

export interface CreateAccountUserRequest {
  accountId: string;
  email: string;
  roles: AccountRole[];
}

export interface UpdateAccountUserRequest {
  roles?: AccountRole[];
}

export enum CustomRole {
  superAdmin = "SuperAdmin",
  user = "User",
}
